import axios from "axios";

export const GET_BRANDS = "v1/vehicles/brands";

export function getBrands() {
  return axios.get(GET_BRANDS);
}

export function getModelsByBrand(brandId) {
  return axios.get(`${GET_BRANDS}/${brandId}/models`);
}
